import { render } from "./AccountSecurityModal.vue?vue&type=template&id=cf0c530c&scoped=true"
import script from "./AccountSecurityModal.vue?vue&type=script&lang=js"
export * from "./AccountSecurityModal.vue?vue&type=script&lang=js"

import "./AccountSecurityModal.vue?vue&type=style&index=0&id=cf0c530c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf0c530c"]])

export default __exports__